import React, { useState, useEffect } from 'react';

export default function SidebarControls({
  numPages,
  pageNumber,
  setPageNumber,
  zoom,
  setZoom,
  highlightMode,
  commentMode,
  notesMode,
  chatboxMode,
  onToggleHighlightMode,
  onToggleCommentMode,
  onToggleNotesMode,
  onToggleChatboxMode,
  isSidebarVisible,
  setSidebarVisible,
  onPreviousPage,
  onNextPage
}) {
  return (
    <div className={`file-browser ${isSidebarVisible ? 'sidebar-visible' : ''}`} id="sidebar">

      {/* Zoom */}
      <ZoomControls zoom={zoom} setZoom={setZoom} />

      {/* Page Navigation */}
      {numPages && (
        <PageNavigation 
          numPages={numPages} 
          pageNumber={pageNumber} 
          setPageNumber={setPageNumber}
          onPreviousPage={onPreviousPage}
          onNextPage={onNextPage}
        />
      )}

      {/* Mode Buttons */}
      <ModeControls
        highlightMode={highlightMode}
        commentMode={commentMode}
        notesMode={notesMode}
        chatboxMode={chatboxMode}
        onToggleHighlightMode={onToggleHighlightMode}
        onToggleCommentMode={onToggleCommentMode}
        onToggleNotesMode={onToggleNotesMode}
        onToggleChatboxMode={onToggleChatboxMode}
      />

      

    </div>
  );
}


function ZoomControls({ zoom, setZoom }) {
  const updateZoom = (newZoom) => {
    if (newZoom >= 0.5 && newZoom <= 3.0) {
      setZoom(newZoom);
    }
  };

  return (
    <div className="sidebar-section">
      <div className="zoom-controls-row">
        <button 
          className="zoom-button" 
          onClick={() => updateZoom(zoom - 0.25)}
          disabled={zoom <= 0.5}
          data-emoji="➖"
          data-title="Zoom Out"
        >
          
        </button>

        <div className="zoom-input-group">
          <input
            type="number"
            value={Math.round(zoom * 100)}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (!isNaN(value)) updateZoom(value / 100);
            }}
            className="zoom-input"
            min="50"
            max="300"
            step="10"
          />
          {/* ADD THE PERCENTAGE TEXT BACK */}
          <span className="zoom-percent">%</span>
        </div>

        <button 
          className="zoom-button" 
          onClick={() => updateZoom(zoom + 0.25)}
          disabled={zoom >= 3.0}
          data-emoji="➕"
          data-title="Zoom In"
        >
          
        </button>
      </div>
    </div>
  );
}


function PageNavigation({ numPages, pageNumber, setPageNumber, onPreviousPage, onNextPage }) {
  const [inputPage, setInputPage] = useState(pageNumber.toString());

  useEffect(() => {
    setInputPage(pageNumber.toString());
  }, [pageNumber]);

  const handleSubmit = () => {
    const n = parseInt(inputPage);
    if (!isNaN(n) && n >= 1 && n <= numPages) {
      setPageNumber(n);
    } else {
      setInputPage(pageNumber.toString());
    }
  };

  return (
    <div className="sidebar-section">
      <div className="nav-controls-row">
        <button 
          onClick={onPreviousPage} 
          disabled={pageNumber <= 1} 
          className="nav-button"
          data-emoji="◀"
          data-title="Previous Page"
        >
          
        </button>

        <div className="page-input-group">
          <input
            type="number"
            min="1"
            max={numPages}
            value={inputPage}
            onChange={(e) => setInputPage(e.target.value)}
            onBlur={handleSubmit}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            className="page-input"
          />
          <span className="page-total">/ {numPages}</span>
        </div>

        <button 
          onClick={onNextPage} 
          disabled={pageNumber >= numPages} 
          className="nav-button"
          data-emoji="▶"
          data-title="Next Page"
        >
          
        </button>
      </div>
    </div>
  );
}


function ModeControls({ 
  highlightMode, commentMode, notesMode, chatboxMode,
  onToggleHighlightMode, onToggleCommentMode, onToggleNotesMode, onToggleChatboxMode
}) {
  return (
    <div className="sidebar-section">
      <div className="mode-buttons-row">
        
     

        <button
          onClick={onToggleCommentMode}
          className={`mode-button ${commentMode ? 'comment-mode-on' : 'comment-mode-off'}`}
          data-emoji="💬"
          data-title="Comment Mode"
        >
          
        </button>

        <button
          onClick={onToggleNotesMode}
          className={`mode-button ${notesMode ? 'notes-mode-on' : 'notes-mode-off'}`}
          data-emoji="📝"
          data-title="Notes Mode"
        >
          
        </button>

        <button
          onClick={onToggleChatboxMode}
          className={`mode-button ${chatboxMode ? 'chatbox-mode-on' : 'chatbox-mode-off'}`}
          data-emoji="🤖"
          data-title="AI Chat"
        >
        </button>
      </div>
    </div>
  );
}